"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));

var _Score = _interopRequireDefault(require("./Score"));

var PageScore =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PageScore, _React$Component);

  function PageScore() {
    (0, _classCallCheck2.default)(this, PageScore);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PageScore).apply(this, arguments));
  }

  (0, _createClass2.default)(PageScore, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          score = _this$props.score,
          overallScore = _this$props.overallScore;
      var scorePercentage = score / overallScore * 100;
      return _react.default.createElement(_Score.default, {
        scorePercentage: scorePercentage
      }, _react.default.createElement("div", {
        className: "score"
      }, score, _react.default.createElement("span", {
        className: "overall"
      }, "/", overallScore)), _react.default.createElement(_ProgressBar.default, {
        scorePercentage: scorePercentage
      }));
    }
  }]);
  return PageScore;
}(_react.default.Component);

exports.default = PageScore;
PageScore.propTypes = {
  score: _propTypes.default.number.isRequired,
  overallScore: _propTypes.default.number.isRequired
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/PageScore.js
// module id = 70
// module chunks = 0